import { createSelector } from 'reselect';

import { StoreState } from './actions';

const rootSelector = (store: any): StoreState => store.authorizationModal;

export const getShouldShowModal = createSelector(rootSelector, (state) => state.shouldShowModal);
